module.exports = __webpack_public_path__ + "toBride2-jp-r-w.6fea1f86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-jp-r-w.jpg
// module id = 4R1R
// module chunks = 0